import React from 'react';

export interface MyComponentProps {
  text?: string
  number?: string
  label?: string
  lineTextViewStyle?: string
}
  
export const LineText: React.FC<MyComponentProps> = (props) => {
  return (
    <div className={props.lineTextViewStyle === "wide" ? "itw-text-wide" : "itw-text-thin"}>
    {props.number && <span>{props.label?.split("(")[0]}/</span>}
    {props.number && <span>{props.number}: </span>}
    <span dangerouslySetInnerHTML={{__html: props.text}} />
    </div>
  );
}